import React from 'react';
import { S } from './CompaniesTableSortDropdown.style';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';

export type SortCompanies =
  | 'none'
  | 'name_ASC'
  | 'name_DESC'
  | 'registrationNumber_ASC'
  | 'registrationNumber_DESC';

type Props = {
  sort: SortCompanies;
  setSort: (value: SortCompanies) => void;
};

export const CompaniesTableSortDropdown: React.FC<Props> = (props) => {
  const sortingOptions = [
    {
      label: 'Inget filter',
      value: 'none',
    },
    {
      label: 'Namn (A-Ö)',
      value: 'name_ASC',
    },
    {
      label: 'Namn (Ö-A)',
      value: 'name_DESC',
    },
    {
      label: 'Org.nr (stigande)',
      value: 'registrationNumber_ASC',
    },
    {
      label: 'Org.nr (fallande)',
      value: 'registrationNumber_DESC',
    },
  ] as const;

  return (
    <S.Root>
      <DropdownMenu.Root>
        <DropdownMenu.Trigger asChild>
          <S.SortButton aria-label="Customise options">
            <S.H6 color="secondary">Sortera</S.H6>
            <S.Icon src="Sort" color="secondary" />
          </S.SortButton>
        </DropdownMenu.Trigger>

        <DropdownMenu.Portal>
          <S.DropDown sideOffset={5}>
            {sortingOptions.map((item) => (
              <S.DropDownItem
                key={item.value}
                onClick={() => props.setSort(item.value)}
              >
                {props.sort === item.value && (
                  <S.Icon
                    src="CheckCircle"
                    width={20}
                    height={20}
                    color="secondary"
                  />
                )}

                <S.DropDownItemText color="secondary">
                  {item.label}
                </S.DropDownItemText>
              </S.DropDownItem>
            ))}
          </S.DropDown>
        </DropdownMenu.Portal>
      </DropdownMenu.Root>
    </S.Root>
  );
};
